@if (showLoader) {
  <div class="loader-overlay">
    <div class="loader-animation">
      <p class="loading-text">{{'syndicate-loading.loading'|translate}} <br>{{'syndicate-loading.please-wait'|translate}}
      </p>
      <ng-lottie width="70%" class="loader-wrapper" [options]="loaderOptions"></ng-lottie>
    </div>
  </div>
}
<!-- this is the progressbar element showing the progress for 45 seconds or unless data is fetched -->
@if (showProgressBar) {
  <div class="progressbar-wrapper">
    <mat-progress-bar class="timer-progress-bar" mode="determinate" [value]="progress * 2.22"></mat-progress-bar>
  </div>
}